export function setRootCssVar(name, value) {
  document.documentElement.style.setProperty(`--${name}`, value)
}
